import { useEffect } from "react";

function useLockBodyScroll(): void {
  useEffect(() => {
    const main = document.querySelector("main") ?? document.body;
    const prevOverflow = main.style.overflow;
    main.style.overflow = "hidden";
    return () => {
      main.style.overflow = prevOverflow;
    };
  }, []);
}

export default useLockBodyScroll;
